"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.betweenMatcherContext = void 0;
function betweenMatcherContext(ruleVO) {
    return function betweenMatcher(runtimeAttr) {
        var isBetween = runtimeAttr >= ruleVO.start && runtimeAttr <= ruleVO.end;
        return isBetween;
    };
}
exports.betweenMatcherContext = betweenMatcherContext;
